/**
 * PresentationResultCard — карточка результата в gw__result-slot для
 * category='presentation'.
 *
 * PPTX нельзя превьюшить в браузере, поэтому показываем:
 *   - Большую иконку формата (📑)
 *   - Имя файла (вычислено из URL или дефолтное)
 *   - Кнопку «Скачать»
 *
 * Mode (edit/create) определяет имя скачиваемого файла.
 */
interface Props {
	resultUrl: string
	mode?: 'edit' | 'create'
}

function fileNameFromUrl(url: string, fallback: string): string {
	try {
		const u = new URL(url)
		const last = u.pathname.split('/').pop()
		if (last && last.toLowerCase().endsWith('.pptx')) return last
	} catch {
		// невалидный URL — используем fallback
	}
	return fallback
}

export default function PresentationResultCard({ resultUrl, mode = 'edit' }: Props) {
	const defaultName =
		mode === 'edit' ? 'presentation_edited.pptx' : 'presentation.pptx'
	const displayName = fileNameFromUrl(resultUrl, defaultName)

	return (
		<div className="pres-result-card">
			<div className="pres-result-card__icon" aria-hidden="true">
				📑
			</div>
			<div className="pres-result-card__meta">
				<div className="pres-result-card__title">{displayName}</div>
				<div className="pres-result-card__subtitle">
					PowerPoint · готово
				</div>
			</div>
			<a
				className="pres-result-card__download"
				href={resultUrl}
				download={defaultName}
				target="_blank"
				rel="noopener noreferrer"
			>
				Скачать
			</a>
		</div>
	)
}
